import { Button } from "../ui/button";
import { RefreshCw } from "lucide-react";
import { AlgorithmFlow } from "../AlgorithmFlow";
import { StepHeader, NavButtons, AiLoader, DdxList } from "../common";
import { useSession } from "../../lib/session";
import { TriageCard, ImmediateActions, SyndromeBanner, AdditionalQuestions, InvestigationPicker } from "./refine/RefineParts";

const RefineResult = ({ r, onRefine }) => (
  <div className="space-y-8">
    {r.triage && <TriageCard triage={r.triage} summary={r.summary} />}
    {r.immediate_actions?.length > 0 && <ImmediateActions items={r.immediate_actions} />}
    <div>
      <h2 className="font-heading text-lg font-semibold mb-3">Refined differential diagnosis</h2>
      <DdxList items={r.ddx} testid="refined-ddx" />
    </div>
    {r.syndrome?.name && <SyndromeBanner syndrome={r.syndrome} />}
    <AlgorithmFlow algo={r.algorithm} testid="diagnostic-algorithm" />
    {r.additional_questions?.length > 0 && <AdditionalQuestions questions={r.additional_questions} />}
    <InvestigationPicker investigations={r.investigations} />
    <Button variant="outline" data-testid="btn-rerun-refine" onClick={onRefine}><RefreshCw className="w-4 h-4 mr-2" />Re-run analysis</Button>
  </div>
);

export default function RefineStep({ loading, onRefine }) {
  const { state, set } = useSession();
  const r = state.refined;
  return (
    <div>
      <StepHeader num={5} title="Refined DDx & Investigations" sub="Updated with vitals, severity scores and examination findings." />
      {loading && <AiLoader text="Refining differential & ordering investigations" />}
      {!loading && !r && <Button className="cc-btn" data-testid="btn-run-refine" onClick={onRefine}>Run syndromic analysis</Button>}
      {!loading && r && <RefineResult r={r} onRefine={onRefine} />}
      <NavButtons onBack={() => set("step", 3)} onNext={() => set("step", 5)} nextLabel="Investigations" />
    </div>
  );
}
